import React from "react";

const ListZones = () => {
  return <div></div>;
};

export default React.memo(ListZones);
